import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Mail, FileUser, Eye } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard({ go }) {
  const [counts, setCounts] = useState({ articles: 0, messages: 0, unread: 0, applications: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/admin/articles").catch(() => ({ data: [] })),
      api.get("/admin/messages").catch(() => ({ data: [] })),
      api.get("/admin/applications").catch(() => ({ data: [] })),
    ]).then(([a, m, c]) => {
      const msgs = m.data || [];
      setCounts({
        articles: (a.data || []).length,
        messages: msgs.length,
        unread: msgs.filter((x) => !x.read).length,
        applications: (c.data || []).length,
      });
    });
  }, []);

  const cards = [
    { label: "Artigos", value: counts.articles, tab: "artigos", icon: <FileText size={18} />, tid: "dash-articles-count" },
    { label: "Mensagens recebidas", value: counts.messages, tab: "mensagens", icon: <Mail size={18} />, tid: "dash-messages-count" },
    { label: "Mensagens não lidas", value: counts.unread, tab: "mensagens", icon: <Eye size={18} />, tid: "dash-unread-count" },
    { label: "Currículos recebidos", value: counts.applications, tab: "curriculos", icon: <FileUser size={18} />, tid: "dash-applications-count" },
  ];

  return (
    <div>
      <h1 className="font-display text-3xl text-navy">Bem-vindo</h1>
      <p className="mt-2 text-sm text-inkgray">
        Gerencie o conteúdo do site, os artigos, as mensagens e as candidaturas recebidas.
      </p>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <button
            key={c.tid}
            data-testid={c.tid}
            onClick={() => go(c.tab)}
            className="flex items-center justify-between border border-navy/10 bg-white p-6 text-left transition-colors hover:border-gold"
          >
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-inkgray/60">{c.label}</p>
              <p className="mt-2 font-display text-4xl text-navy">{c.value}</p>
            </div>
            <span className="text-gold-deep">{c.icon}</span>
          </button>
        ))}
      </div>
      <div className="mt-8 border border-navy/10 bg-white p-6">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-gold-deep">Acesso rápido</p>
        <div className="mt-4 flex flex-wrap gap-3">
          <button data-testid="dash-go-paginas" onClick={() => go("paginas")} className="bg-navy px-5 py-3 text-[11px] font-bold uppercase tracking-[0.18em] text-ivory hover:bg-navy-2">
            Editar páginas
          </button>
          <Link to="/conteudo-juridico" data-testid="dash-view-conteudo" className="border border-navy/20 px-5 py-3 text-[11px] font-bold uppercase tracking-[0.18em] text-navy hover:border-gold">
            Ver conteúdos publicados
          </Link>
        </div>
      </div>
    </div>
  );
}
